import { FileModel } from "./file.model";

export class ConditionReportModel {

  reportUid: number;
  assetUid: number;
  clientUid: number;
  
  conditionReportUid: number;
  conditionReportDateTime: string;
  condition: string;
  userName: string;
  photos: Array<FileModel> = [];

  summary: string;
  approxAge: string;
  columnType: string;
  columnTypeOther: string;
  headType: string;
  headTypeOther: string;
  notes: string;

  assetName: string;
  shortDescription: string;
  longDescription: string;
  assetTypeName: string;
  assetTypeUid: number;
  loggedByUserUid: number;
  locationName: string;
  loggedByUserEmail: string;
  reportCreatedDateTime: string;
  
  lastJobDateTime: string;
  
  hasImages: boolean;

  constructor() {
  }
}